import React from "react";

/*
========================================================
MANAGE BILLING BUTTON
--------------------------------------------------------
Purpose:
- Opens Stripe customer portal (later real URL)
========================================================
*/

export default function ManageBillingButton({ onClick, busy }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      style={{
        padding: "10px 16px",
        background: "#00c2ff",
        border: "none",
        borderRadius: 8,
        cursor: busy ? "not-allowed" : "pointer",
        color: "#062033",
        fontWeight: 700,
        opacity: busy ? 0.75 : 1,
      }}
    >
      {busy ? "Opening..." : "Manage Billing"}
    </button>
  );
}
